import { formatDistanceToNowStrict, isToday, parseISO } from 'date-fns';

export const generateRelativeDateFromUTCTimestamp = (timestamp: string): string => {
  const date = parseISO(timestamp);
  if (isToday(date)) return 'Today';

  return `${formatDistanceToNowStrict(date)} ago`;
};
